// Фільтри відгуків: до цього на сторінці відгуків фільтра не було зовсім.
export const REVIEWS_FILTERS = [
  {
    key: 'status',
    type: 'checkbox',
    label: 'Видимість',
    options: [
      { value: 'active', label: 'Показані на сайті' },
      { value: 'inactive', label: 'Приховані' },
    ],
  },
  {
    key: 'media',
    type: 'checkbox',
    label: 'Відео',
    options: [
      { value: 'with', label: 'З відео' },
      { value: 'without', label: 'Без відео' },
    ],
  },
];

export const useReviewsFilters = () => REVIEWS_FILTERS;
